export const LogoutUrl = "/informat/Retry";
export const LogoutAction = () => window.location.href = LogoutUrl;

export const Start2FaFlowUrl = "/informat/2FA";

export const AccountsApi = "/informat/AvailableAccounts";

export const ExternalLoginAction = (pInstallatie: number, gebruikerId: string) =>
    window.location.href = `/Account/ExternalLoginCallback?pInstallatie=${encodeURIComponent(pInstallatie)}&gebruikerId=${encodeURIComponent(gebruikerId)}`;
